module.exports = __webpack_public_path__ + "img/ryzz.bc140e4.bc140e40.jpg";